import styled from 'styled-components';

import { QuestionMarkIcon } from '../../assets';

export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary.c100};
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  margin: 0 0.375rem;
`;

export const StyledQuestionMarkIcon = styled(QuestionMarkIcon)`
  opacity: 1;
  fill: ${({ theme }) => theme.colors.primary.c400};
  width: 0.5rem;
  height: 0.5rem;
`;

export const TooltipContent = styled.div`
  color: ${({ theme }) => theme.colors.primary.c100};
  font-size: ${({ theme }) => theme.fontSize.s};
  font-family: ${({ theme }) => theme.fonts.primary};
`;
